//
// Module for the Death Step wizard's Interest step
//
rs.module("participant/benefit/setup/death/wizard/intereststep",

    ["common/select-helper"],

    function (selectHelper) {

        // Initialize the module
        function initialize(jsSelectors) {

            // get JS selectors
            var stepContainer = $.js(jsSelectors.stepContainer);
            var skipInterestCheckBox = stepContainer.js(jsSelectors.skipInterestCheckBox);
            var asOfDateInput = stepContainer.js(jsSelectors.asOfDateInput);
            var accruedDateInput = stepContainer.js(jsSelectors.accruedDateInput);
            var planSelect = stepContainer.js(jsSelectors.planSelect);
            var planSelectHelper = selectHelper.getHelper(planSelect);
            var availableContributionTypeSelect = stepContainer.js(jsSelectors.availableContributionTypeSelect);
            var availableContributionTypeSelectHelper = selectHelper.getHelper(availableContributionTypeSelect);
  
            // Enable/disable interest fields on skipInterestCheckBox change
            skipInterestCheckBox.change(function () {

                asOfDateInput.prop("disabled", this.checked).val("").clearErrors();
                accruedDateInput.prop("disabled", this.checked).val("").clearErrors();
                planSelectHelper.setDisabled(this.checked).setValue("");
                planSelect.clearErrors();
                availableContributionTypeSelectHelper.setDisabled(this.checked).setValue("");
                availableContributionTypeSelect.clearErrors();
            });       
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);